// typescript: universal base64 encode/decode (browser + node), supports unicode
export function base64Encode(input: string, stripPadding = true): string {
    // Browser environment (btoa/atob) may fail with non-latin1, so we use TextEncoder if available.
    if (typeof Buffer !== 'undefined' && typeof Buffer.from === 'function') {
        // Node.js
        const encoded = Buffer.from(input, 'utf8').toString('base64')
        return stripPadding ? encoded.replace(/=+$/, '') : encoded
    } else {
        // Browser
        const encoder = new TextEncoder()
        const bytes = encoder.encode(input)
        // convert bytes to binary string for btoa
        let binary = ''
        for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i] || 0)
        }
        const encoded = btoa(binary)
        return stripPadding ? encoded.replace(/=+$/, '') : encoded
    }
}

export function base64Decode(b64: string): string {
    // allow inputs without padding
    const padded = b64 + '=='.slice((2 - (b64.length % 4)) % 4)

    if (typeof Buffer !== 'undefined' && typeof Buffer.from === 'function') {
        // Node.js
        return Buffer.from(padded, 'base64').toString('utf8')
    } else {
        // Browser
        const binary = atob(padded)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i++) {
            bytes[i] = binary.charCodeAt(i)
        }
        const decoder = new TextDecoder()
        return decoder.decode(bytes)
    }
}

export const formattedDate = (date: string) => {
    const dateObject = new Date(date)

    return dateObject.toLocaleDateString('en-US', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })
}

export const formatDateDMY = (date: string): string => {
    if (!date || date === '-') return '-'

    try {
        const dateObject = new Date(date)
        if (isNaN(dateObject.getTime())) return '-'

        const day = dateObject.getDate().toString().padStart(2, '0')
        const month = (dateObject.getMonth() + 1).toString().padStart(2, '0')
        const year = dateObject.getFullYear()

        return `${day}/${month}/${year}`
    } catch {
        return '-'
    }
}

export const getFullRank = (rankShort: string) => {
    switch (rankShort) {
        case 'DIA':
            return 'Chủ Tịch Kim Cương'
        case 'PrR':
            return 'Chủ Tịch Hồng Ngọc'
        case 'PrS':
            return 'Chủ Tịch Ngọc Bích'
        case 'PrD':
            return 'Chủ Tịch Giám Đốc'
        case 'ExD':
            return 'Giám Đốc Điều Hành'
        case 'SrD':
            return 'Giám Đốc Cấp Cao'
        case 'SrM':
            return 'Quản lý cấp cao'
        case 'Dir':
            return 'Giám Đốc'
        case 'ExM':
            return 'Quản Lý Điều Hành'
        case 'Ph1':
            return 'Giai đoạn 1'
        case 'Mgr':
            return 'Quản Lý'
        case 'Dst':
            return 'Nhà phân phối'
        case 'Asc':
            return 'Nhà phân phối'
        default:
            return ''
    }
}

export const getBaStatus = (status: string) => {
    switch (status) {
        case 'Active':
            return 'đang hoạt động'
        case 'Suspended':
            return 'Đang tạm đình chỉ hoạt động'
        case 'T':
            return 'Đã chấm dứt hoạt động'
        default:
            return '-'
    }
}